export default {
	name: 'Profile',
	path: 'profile',
	meta: {
		auth: true,
		isAccount: true
	}
}